import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './translations/en.json'
import es from './translations/es.json'
import pt from './translations/pt.json'

const resources = {
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
  pt: {
    translation: pt,
  },
}

const customUrlLanguageDetector = {
  name: 'urlLangDetector',
  lookup: () => {
    const params = new URLSearchParams(window.location.search)
    const lang = params.get('lang') // Obtén el valor del parámetro "lang"

    return lang ?? undefined // Retorna 'undefined' en lugar de 'null' si no existe
  },
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector(customUrlLanguageDetector)

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init(
    {
      detection: {
        order: ['urlLangDetector', 'navigator'], // Priotize custom detector
        caches: [], // Avoid save in cookies
      },
      resources,
      fallbackLng: 'es',

      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    },
    (error, t) => {
      if (error) {
        console.error('Error during i18n init:', error)
      } else {
        const lang = i18n.language
        const currentUrl = new URL(window.location.href)
        currentUrl.searchParams.set('lang', lang)
        window.history.replaceState({}, '', currentUrl.toString())
      }
    }
  )

export default i18n
